import { reactive, type Ref, ref, watchEffect } from 'vue'
import { cloneDeep } from 'lodash'
import useValidate from '@/shared/lib/validate'
import { useLoadInventObjectType } from '@/entities/Inventory/ObjectTypes'
import { defineStore } from 'pinia'
import { type ObjectTypeDataPayloads, useLoadTypesData } from '@/entities/Manuals/ObjectTypes'

export const useObjectSubTypeModel = defineStore('object_subtype_form', () => {
  const { required } = useValidate()

  const payload = reactive<ObjectTypeDataPayloads>({
    types: [],
    figures: [],
    lines: [],
  })

  const fields: any = {
    id: 0,
    figure_id: 1,
    object_type: {
      id: 3,
      is_system: false,
    },
    name: '',
    group_id: 0,
    dependency: 0,
    styles: {
      fill: '#1976D23F',
      stroke: {
        color: '#FF0000FF',
        width: 1,
        line_id: 1,
        dash: [],
      },
    },
    fields: [],
    properties: {
      zoom: 0,
      has_file: false,
      is_bind: false,
      is_journal_replace: false,
      is_must_accept: false,
      is_connection_to_object: false,
      is_tree: false,
      is_comment: false,
      description: '',
    },
    catalog_changing: [],
    invent_object_actions: [],
    parent_invent_type_id: 0,
  }

  const data = ref(cloneDeep(fields))

  /* Правила валидации */
  const rules = {
    name: [(value: string) => required(value)],
  }

  /**
   * Функция приведения к дефолтным значениям
   */
  const clearData = () => {
    Object.keys(data.value).forEach((key) => {
      data.value[key] = fields[key]
    })
  }

  /**
   * Функция загрузки данных
   * @param objectTypeId
   * @param objectId
   */
  const loadData = (objectTypeId: Ref<string>, objectId: Ref<string>) => {
    const result = useLoadInventObjectType(objectTypeId, objectId)

    watchEffect(() => {
      if (result.data.value) {
        data.value = cloneDeep({
          ...result.data.value.data,
          invent_object_actions: result.data.value.data.invent_object_actions || [],
        })
      }
    })

    return result
  }

  /**
   * Загрузка дополнительных данных (типы объектов, фигуры, линии) по типам
   */
  const loadPayloads = () => {
    const result = useLoadTypesData()

    watchEffect(() => {
      if (result.data.value) {
        payload.types = result.data.value.data.types
        payload.figures = result.data.value.data.figures
        payload.lines = result.data.value.data.lines
      }
    })

    return result
  }

  return {
    data,
    rules,
    payload,

    clearData,
    loadData,
    loadPayloads,
  }
})
